
interface ColumnProps {
  children: React.ReactNode;
}

export default function Column({ children }: ColumnProps) {
  return <div className="l-columns__column">{children}</div>;
}
